import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Alert, CircularProgress } from '@mui/material';

const DatabaseTest = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleTest = async () => {
    if (!email || !password) {
      setError('Please enter email and password');
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const { testDatabaseWrite } = await import('../firebase-test');
      const success = await testDatabaseWrite(email, password);
      setResult(success ? 'Test successful! Data was written to the database.' : 'Test failed.');
    } catch (err) {
      console.error('Error running test:', err);
      setError(`Test error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        Database Write Test
      </Typography>
      
      <Typography variant="body2" sx={{ mb: 2 }}>
        This tool tests writing to the Firebase database directly. Enter your credentials to run the test.
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      
      {result && (
        <Alert severity={result.includes('successful') ? 'success' : 'warning'} sx={{ mb: 2 }}>
          {result}
        </Alert>
      )}
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
        />
        
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
        />
      </Box>
      
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleTest} 
        disabled={loading}
        startIcon={loading && <CircularProgress size={20} color="inherit" />}
      >
        {loading ? 'Testing...' : 'Run Database Test'}
      </Button>
    </Box>
  );
};

export default DatabaseTest; 